var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{class:{ flipped: _vm.orientation === -1, marked: _vm.marked === true, shaking: _vm.shaking === true },attrs:{"src":require('@/assets/baseballcap_left.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }